import { Component, OnInit } from '@angular/core';
import { StatePersistService } from '../core/services/state-persist.service';
import { Apollo, QueryRef } from 'apollo-angular';
import gql from 'graphql-tag';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { HomeModuleConsts } from './constants';
import { VersionCheck } from '../core/services/version-check.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { SharedState } from '../shared/store/reducers';
import { getBrands } from '../shared/store/selectors/shared.selectors';
import { HomeService } from './services/home.service';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  message: any;
  global_data: any ={};
  selectedStore: any={};
  onhold: boolean = true;
  onhold_with_depot: boolean = false;
  HOME_QUERY = gql`
  query  {
    textBanners{
      id
    textMessage
    updatedAt
      }
}
`;

getBrandsSubscirber$:Subscription;
topBrandsListing:Array<any>=[];
brandsListing:Array<any>=[];
headerBrandsAlphabet:Array<any>=[];

private query: QueryRef<any>;
  constructor(
    private titleService: Title,
    private statePersistService: StatePersistService,
    private apollo: Apollo, 
    private router: Router,
    private versionCheck:VersionCheck,
    private store:Store<SharedState>,
    private homeService:HomeService,
    private statePersiste: StatePersistService) { }

  ngOnInit(): void {
    this.selectedStore = this.statePersiste.getLocalStorage('selectedStoreAddress')

    try{
      this.versionCheck.initVersionCheck(environment.versionCheckURL);
     }catch(e){
       console.log(e)
     }
    this.onInitHelper();
    this.getBrandsListFromStore();
    localStorage.removeItem('promotion_tag_name')
    this.statePersiste.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersiste.getLocalStorage('global_data')
    })
    
  }


  async getBrandsListFromStore(){
    const config_store$ = await this.store.pipe(select(getBrands));
    this.getBrandsSubscirber$ = config_store$.subscribe(res=>{
      if(Object.keys(res).length){
        this.topBrandsListing = [...res?.topBrands];
        this.brandsListing = this.homeService.groupBrands([...res.brandsList,...res?.topBrands]);
        this.headerBrandsAlphabet = this.homeService.groupBrandsByAlpModal([...res.brandsList,...res?.topBrands]);
      }
    });
  }



  onInitHelper():void{
    this.titleService.setTitle(HomeModuleConsts.HOME_PAGE_TITLE);
    this.statePersistService.setLocalStorage('previous_url', this.router.url)
    this.statePersistService.watchHomePageStorage().subscribe(message => {
      window.location.reload()
      
    })
    this.statePersistService.setLocalStorage('address-disabled', false)
    this.statePersistService.removeLocalStorage('product_data')
    this.query = this.apollo.watchQuery({
      query: this.HOME_QUERY,
      variables: {}
    });
    this.query.valueChanges.subscribe(result => {
      this.message = result.data?.textBanners[0].textMessage; 
    });
  }

  ngAfterViewInit() {
    if (this.statePersistService.getLocalStorage('scrollToHomepageElement') != null){
      let scrollToElement=this.statePersistService.getLocalStorage('scrollToHomepageElement')
      this.statePersistService.removeLocalStorage('scrollToHomepageElement')

      var checkExist = setInterval(function() {
        if (document.getElementById(scrollToElement)) {
           document.getElementById(scrollToElement).scrollIntoView({behavior: 'smooth'});
           clearInterval(checkExist);
        }
     }, 100); // check every 100ms

    }
  }


  

}
